import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Collapse,
  Label,
  FormGroup,
  Input,
} from "reactstrap";
// import history from "../../history";
import moment from "moment";
import CartTitle from "../CartTitle";
import Loader from "../Loader";
import MaterialTable from "material-table";
import CustomDatepicker from "../CustomDatepicker";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  helperFunctionForCountry,
  helperFunctionForBooleanValue,
  helperFunctionForDate,
} from "../../utils/helperFunction";

import "../../assets/scss/components/MeterialTable/index.scss";

import InputText from "../InputText";
import CustomButton from "../CustomButton";
import get from "lodash/get";
import NonMemberDetailsPage from "../NonmemberDetailsPage";

const _ = { get };

export default class NonMembersReportsListing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleActive: true,
      toggleCollapse: false,
      pageSize: 10,
      page: 0,
      count: 100,
      startDate: new Date("04/01/2021"),
      endDate: new Date().setFullYear(new Date().getFullYear()),
      email: "",
      countryCode: "",
      country: "",
      countryList: [],
      parsedCountry: "",
    };
  }

  componentDidMount() {
    let obj = {
      page: this.state.page,
      count: this.state.count,
      startDate: moment(this.state.startDate).format("DD/MM/YYYY"),
      endDate: moment(this.state.endDate).format("DD/MM/YYYY"),
      countryCode: this.state.countryCode,
    };
    this.props.handleFetchNonMemebersReports(obj);
    this.handleSetCountries();
  }

  componentDidUpdate(prevProps, prevState) {
    let countries = JSON.parse(localStorage.getItem("countries"));
    let accessibleCountries = JSON.parse(
      localStorage.getItem("accessCountries")
    );
    console.log(accessibleCountries, countries);
    if (
      prevProps.nonMembersReportsList.length !==
      this.props.nonMembersReportsList.length
    ) {
      let state = this.state;
      state.page = Math.ceil(
        this.props.nonMembersReportsList.length / this.state.count
      );
      this.setState({ ...state });
    }
  }

  handleSetCountries = () => {
    let countries = JSON.parse(localStorage.getItem("countries"));
    let accessibleCountries = JSON.parse(
      localStorage.getItem("accessCountries")
    );
    console.log(accessibleCountries, countries);
    if (accessibleCountries && accessibleCountries[0] === "*") {
      let state = this.state;
      state.countryList = countries;
      console.log("===Star state===", this.state.countryList);
      this.setState({ ...state });
    }
    if (accessibleCountries && accessibleCountries[0] !== "*") {
      let state = this.state;
      let newCountry = countries.filter((data) =>
        accessibleCountries.includes(data.locality.country)
      );
      state.countryList = newCountry;
      let code = newCountry[0].locality.country;
      let countryName = newCountry[0].country;

      state.countryCode = code;
      state.country = countryName;
      console.log("===Non Star state===", this.state.countryList);
      this.setState({ ...state });
    }
  };

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    if (state.toggleCollapse === true) {
      state.toggleCollapse = !state.toggleCollapse;
      this.setState({ ...state });
    }
    this.setState({ ...state });
  };
  handleToggleIcon = (e) => {
    let state = this.state;
    state.toggleCollapse = !state.toggleCollapse;
    if (state.toggleActive === true) {
      state.toggleActive = !state.toggleActive;
      this.setState({ ...state });
    }
    this.setState({ ...state });
  };
  handleOnChangePageSize = (count) => {
    let state = this.state;
    state.pageSize = count;
    this.setState({ ...state });
  };

  handleEmailChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleOnPageChange = (e, page) => {
    let totalPages =
      this.props.nonMembersReportsList.length / this.state.pageSize;
    let fetchNextData =
      e >= totalPages - 2 &&
      this.props.nonMembersReportsList.length !== 0 &&
      this.props.nonMembersReportsList.length <
        this.props.nonMembersReportsListCount;

    if (fetchNextData === true) {
      let obj = {
        page: this.state.page,
        count: this.state.count,
        startDate: moment(this.state.startDate).format("DD/MM/YYYY"),
        endDate: moment(this.state.endDate).format("DD/MM/YYYY"),
        countryCode: this.state.countryCode,
      };
      this.props.handleFetchNonMemebersReports(obj);
    }
  };

  handleFilterDates = (date, id) => {
    let state = this.state;
    if (id === "start") {
      state.startDate = date;
      state.endDate = "";
      this.setState({ ...state });
    }
    if (id === "end") {
      state.endDate = date;
      this.setState({ ...state });
    }
  };

  handleClearFilter = () => {
    let state = this.state;
    state.startDate = "";
    state.endDate = "";
    state.country = "";
    state.parsedCountry = "";
    this.setState({ ...state });
    let obj = {
      page: 0,
      count: this.state.count,
      startDate: "",
      endDate: "",
      countryCode: "",
      country: "",
    };

    this.props.handleFetchNonMemebersReports(obj);
    this.props.clearingPreviousReducer();
  };

  handleCountryChange = (e) => {
    let state = this.state;
    if (e.target.value !== "") {
      let parsedValue = JSON.parse(e.target.value);
      state.countryCode = parsedValue.locality.country;
      state.country = parsedValue.country;
    } else {
      state.countryCode = "";
      state.country = "";
    }
    state.parsedCountry = e.target.value;
    this.setState({ ...state });
  };

  handleExportData = (e) => {
    let state = this.state;
    let { elements } = this.props;
    let obj = {
      email: state.email,
      startDate: state.startDate
        ? moment(state.startDate).format("DD/MM/YYYY")
        : "",
      endDate: state.endDate ? moment(state.endDate).format("DD/MM/YYYY") : "",
      countryCode: state.countryCode,
    };
    if (state.email === "")
      return toast.error(
        _.get(
          elements,
          "nonmemberListingElement.emailValidationElement",
          "Email cannot be empty"
        )
      );
    return this.props.handleExportToExcel(obj, "nonMembersReports");
  };

  handleSearch = () => {
    let state = this.state;
    let obj = {
      page: 0,
      count: state.count,
      startDate: state.startDate
        ? moment(state.startDate).format("DD/MM/YYYY")
        : "",
      endDate: state.endDate ? moment(state.endDate).format("DD/MM/YYYY") : "",
      countryCode: state.countryCode,
    };
    this.props.clearingPreviousReducer();
    this.props.handleFetchNonMemebersReports(obj);
  };

  render() {
    let { elements } = this.props;
    return (
      <div className="userListing hideSearch">
        {this.props.fetchingNonMembersReports !== false ? <Loader /> : null}
        {this.props.exportToExcelStatus !== false ? <Loader /> : null}
        <Row>
          <Col sm={12}>
            <CartTitle
              title={_.get(
                elements,
                "nonmemberListingElement.headingElement",
                "Non-Member"
              )}
              Name={_.get(
                elements,
                "nonmemberListingElement.filterButtonElement",
                "Filter"
              )}
              handleToggle={() => this.handleToggle()}
              customExcelClick={() => this.handleToggleIcon()}
              textTitle={_.get(
                elements,
                "nonmemberListingElement.totalCountElement",
                "Total Count - "
              )}
              preRegisteredUserCount={this.props.nonMembersReportsListCount}
            />
          </Col>

          <Col sm={12}>
            <Collapse isOpen={this.state.toggleActive}>
              <Card className="mb-3">
                <CardBody>
                  <Row>
                    <Col xl={4} lg={4} md={6} sm={6}>
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "nonmemberListingElement.selectCountryLabelElement",
                          "Select Country"
                        )}{" "}
                      </Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        {this.props.accessibleCountries &&
                        this.props.accessibleCountries.length === 1 &&
                        this.props.accessibleCountries[0] !== "*" ? (
                          <Input
                            type="select"
                            name="City"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleCountryChange}
                            value={this.state.parsedCountry}
                          >
                            {this.state.countryList &&
                              this.state.countryList.length > 0 &&
                              this.state.countryList
                                .sort((a, b) =>
                                  a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                                )
                                .map((item, index) => (
                                  <option
                                    key={index}
                                    value={JSON.stringify(item)}
                                  >
                                    {item.country}
                                  </option>
                                ))}
                          </Input>
                        ) : (
                          <Input
                            type="select"
                            name="City"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleCountryChange}
                            value={this.state.parsedCountry}
                          >
                            <option value="">
                              {_.get(
                                elements,
                                "nonmemberListingElement.countryLabel",
                                "All Countries"
                              )}
                            </option>
                            {this.state.countryList &&
                              this.state.countryList.length > 0 &&
                              this.state.countryList
                                .sort((a, b) =>
                                  a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                                )
                                .map((item, index) => (
                                  <option
                                    key={index}
                                    value={JSON.stringify(item)}
                                  >
                                    {item.country}
                                  </option>
                                ))}
                          </Input>
                        )}
                      </FormGroup>
                    </Col>
                    <Col lg={4} className="mb-3 mb-lg-0">
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "nonmemberListingElement.startDateLabelElement",
                          "Start Date"
                        )}{" "}
                      </Label>
                      <FormGroup>
                        <CustomDatepicker
                          value={this.state.startDate}
                          customPlaceHolder={_.get(
                            elements,
                            "nonmemberListingElement.startDatePlaceHolderElement",
                            "Select Start Date"
                          )}
                          handleDateChange={(e) =>
                            this.handleFilterDates(e, "start")
                          }
                          customShowMonthDropdown={true}
                          customShowYearDropdown={true}
                          customMaxDate={new Date()}
                          // customMinDate={new Date("04/01/2021")}
                        />
                      </FormGroup>
                    </Col>

                    <Col lg={4} className="mb-3 mb-lg-0">
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "nonmemberListingElement.endDateLabelElement",
                          "End Date"
                        )}
                      </Label>
                      <FormGroup>
                        <CustomDatepicker
                          value={this.state.endDate}
                          customPlaceHolder={_.get(
                            elements,
                            "nonmemberListingElement.endDatePlaceHolderElement",
                            "Select End Date"
                          )}
                          handleDateChange={(e) =>
                            this.handleFilterDates(e, "end")
                          }
                          customShowMonthDropdown={true}
                          customShowYearDropdown={true}
                          customMinDate={this.state.startDate}
                          // customMaxDate={new Date()}
                          customDisable={
                            this.state.startDate === "" ? true : false
                          }
                          // customMaxDate={new Date()}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      lg={12}
                      className="d-flex align-items-center justify-content-end"
                    >
                      <div className="d-flex mt-3">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "userListingFilterElements.searchButtonElement",
                            "Search"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          customClick={() => this.handleSearch()}
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "userListingFilterElements.clearFilterButtonElement",
                            "Clear Filter"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          customClick={() => this.handleClearFilter()}
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Collapse>
            <Collapse isOpen={this.state.toggleCollapse}>
              <Card className="mb-3">
                <CardBody>
                  <Row className="justify-content-start">
                    <Col lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "nonmemberListingElement.emailLabel",
                          "Email"
                        )}
                        inputType={"email"}
                        inputName={"email"}
                        InputClass={"inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "nonmemberListingElement.emailPlaceholder",
                          "Email"
                        )}
                        customValue={this.state.email}
                        customOnChange={(e) => this.handleEmailChange(e)}
                      />
                    </Col>

                    <Col
                      lg={2}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <div className="mt-2 pt-1 w-100">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "nonmemberListingElement.exportToExcelButtonElement",
                            "Export To Excel"
                          )}
                          customClass={"btn-outline-dark bg-none btnthemeColor"}
                          customClick={() => this.handleExportData()}
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Collapse>
          </Col>
        </Row>
        <Row>
          <Col sm="12">
            <div className="custom-m-table">
              <MaterialTable
                title=""
                columns={[
                  {
                    title: _.get(
                      elements,
                      "nonmemberListingElement.nameElement",
                      "Name"
                    ),
                    field: "fullName",
                    render: (rowData) => {
                      return `${rowData.fName} ${rowData.lName}`;
                    },
                  },
                  {
                    title: _.get(
                      elements,
                      "nonmemberListingElement.phoneElement",
                      "Phone"
                    ),
                    field: "number",
                  },

                  {
                    title: _.get(
                      elements,
                      "nonmemberListingElement.emailElement",
                      "Email"
                    ),
                    field: "email",
                  },

                  {
                    title: _.get(
                      elements,
                      "nonmemberListingElement.countryElement",
                      "Country"
                    ),
                    field: "country",
                  },
                  {
                    title: _.get(
                      elements,
                      "memberListingElement.sourceElement",
                      "Source"
                    ),
                    field: "source",
                  },
                  {
                    title: _.get(
                      elements,
                      "nonmemberListingElement.createdOnElement",
                      "Created on"
                    ),
                    field: "createdOn",

                    render: (rowData) => {
                      return helperFunctionForDate(rowData.createdAt);
                    },
                  },
                ]}
                data={this.props.nonMembersReportsList}
                options={{
                  actionsColumnIndex: -1,
                  search: false,
                  paging: true,
                  sorting: false,
                  pageSize: this.state.pageSize,
                  paginationType: "stepped",
                  initialPage: 1,
                  showFirstLastPageButtons: false,
                }}
                onChangeRowsPerPage={(e) => this.handleOnChangePageSize(e)}
                onChangePage={(e, page) => this.handleOnPageChange(e, page)}
                localization={{
                  body: {
                    emptyDataSourceMessage: (
                      <h6>
                        {_.get(
                          elements,
                          "nonmemberListingElement.noRecordsFoundElement",
                          "No records to display"
                        )}
                      </h6>
                    ),
                  },
                  pagination: {
                    labelRowsSelect: _.get(
                      elements,
                      "customMaterialTableElement.labelRowsSelect",
                      "rows"
                    ),
                    previousTooltip: _.get(
                      elements,
                      "customMaterialTableElement.previousTooltip",
                      "previous"
                    ),
                    nextTooltip: _.get(
                      elements,
                      "customMaterialTableElement.nextTooltip",
                      "next"
                    ),
                  },
                  header: {
                    actions: _.get(
                      elements,
                      "nonmemberListingElement.actionsElement",
                      "Actions"
                    ),
                  },
                }}
                detailPanel={(rowData) => (
                  <NonMemberDetailsPage
                    rowData={rowData}
                    elements={this.props.elements}
                  />
                )}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
